export const websiteOffer = {
  price: '$995',
  deposit: '$497.50',
  recurringCosts: 'Basic hosting is included. Domain registration and renewal are separate, agreed before you pay.',
  pages: ['Home', 'Services', 'Projects', 'About', 'Contact'],
  inclusions: [
    'Up to five pages, designed for your business',
    'Mobile design with a tap-to-call button',
    'Copy prepared from our short interview',
    'A gallery of your finished projects',
    'One quote form, with email delivery tested before launch',
    'Page titles, descriptions, and launch setup',
    'Basic hosting, with no ongoing Verno hosting fee',
    'Two rounds of revisions',
    'Your site files and account handover after final payment',
  ],
  exclusions: 'Online stores, custom apps, booking-system builds, CRM automation, advertising, ongoing SEO, and continuing edits are quoted separately.',
};

export const demoAvailability = {
  timeZone: 'America/Los_Angeles',
  durationMinutes: 10,
  weekdays: 'Monday–Friday: noon–1 pm and 5–8 pm',
  weekends: 'Saturday–Sunday: 8 am–8 pm',
};

// Public Google schedule, configured in Nate's calendar. An environment value can override it.
export function getDemoBookingUrl() {
  const value = import.meta.env.VITE_DEMO_BOOKING_URL?.trim() || 'https://calendar.app.google/qL45LKkxApwZxiTS7';
  try {
    const url = new URL(value);
    return url.protocol === 'https:' ? url.href : '';
  } catch {
    return '';
  }
}

export function getDemoAttribution() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  // Only campaign identifiers; never copy arbitrary query strings or contact details.
  return Object.fromEntries(['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
    .flatMap((key) => {
      const value = params.get(key);
      return value ? [[key, value.slice(0, 200)]] : [];
    }));
}
